

export const PROVIDER_REQUEST_STATUS = {
    Pending: 1,
    Accepted: 2,
    Rejected: 3 ,
}

export const PATIENT_REQUEST_STATUS = {
    Pending: 1,
    InformationRequested: 2,
    InformationResponded: 3,
    Accepted: 4,
    AwaitingInitialPayment: 5,
    InitialPaymentReceived: 6,
    InProgress: 7,
    Completed: 8,
    Discharged: 9,
    Declined: 10,
}

export  const PROVIDER_REQUEST_SCREENS  = [
{label :"in-review", value :PROVIDER_REQUEST_STATUS.Pending},
{label :"accepted", value :PROVIDER_REQUEST_STATUS.Accepted},
{label :"rejected", value :PROVIDER_REQUEST_STATUS.Rejected},

]

export const PROVIDER_REQUEST_STATUS_MAP = {
    [PROVIDER_REQUEST_STATUS.Pending]: {
        class: "pending-status",
        label: "in-review"
    },
    [PROVIDER_REQUEST_STATUS.Accepted]: {
        class: "accepted-status",
        label: "accepted"
    },
    [PROVIDER_REQUEST_STATUS.Rejected]: {
        class: "rejected-status",
        label: "rejected"
    }
}